import { useEffect } from 'react';

export const useJQueryInit = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || !window.jQuery) return;
    const $ = window.jQuery;

    const initPlugins = () => {
      // mobile menu
      if ($('.th-menu-wrapper').length && typeof $.fn.thmobilemenu === 'function') {
        if (!$('.th-menu-wrapper').data('initialized')) {
          try {
            $('.th-menu-wrapper').thmobilemenu();
            $('.th-menu-wrapper').data('initialized', true);
          } catch (e) {
            console.log('Mobile menu init skipped', e);
          }
        }
      }

      // backgrounds
      if ($('[data-bg-src]').length) {
        $('[data-bg-src]').each(function () {
          const src = $(this).attr('data-bg-src');
          if (src && !src.includes('.html')) {
            $(this).css('background-image', `url(${src})`);
          }
        });
      }

      // scroll-top wiring (if main.js didn't)
      const $btn = $('.scroll-top');
      if ($btn.length) {
        const offset = 50;
        $(window).on('scroll', () => {
          if ($(window).scrollTop() > offset) $btn.addClass('show');
          else $btn.removeClass('show');
        });
        $btn.on('click', (e) => {
          e.preventDefault();
          $('html, body').animate({ scrollTop: 0 }, 600);
        });
      }
    };

    const timer = setTimeout(initPlugins, 100);
    return () => clearTimeout(timer);
  }, []);
};
 
